import { useCallback } from "react";

import { ConfigInput } from "types/generated";
import { createDefaultMutationHook } from "hooks/useMutationHandler";
import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";

import { INTENT_PROJECT_CONFIG_ADD } from "./gql";

const addConfigHook = createDefaultMutationHook(INTENT_PROJECT_CONFIG_ADD);

const useIntentProjectConfigAdd = () => {
  const { reportSuccess } = useTypedContext(FlashContext);

  const [addConfig, { loading, error }] = addConfigHook({
    refetchQueries: ["GetIntentProject", "GetIntentProjectConfig"],
  });

  const addConfigToIntentProject = useCallback(
    (intentProjectId: string, config: ConfigInput, callback?: () => void) => {
      addConfig({ project: intentProjectId, config: config }, (data) => {
        if (data?.intentProjectConfigAdd?.id) {
          reportSuccess({ message: "Config was successfully added." });
          callback?.();
        }
      });
    },
    [addConfig, reportSuccess]
  );

  return {
    addConfigToIntentProject,
    loading,
    error,
  };
};

export default useIntentProjectConfigAdd;
